<template>
  <div class="account-aside">
    <AccountAsideMainInfos />
    <hr />
    <div class="extended-infos">
      <AccountAsideExtendedItem
        v-if="profile.displayName"
        label="Pseudo"
        :value="profile.displayName"
        :orientation="orientationInfo"
      />
      <AccountAsideExtendedItem
        v-if="user.birthdate"
        label="Date de naissance"
        :value="formatedBirthDate"
        :orientation="orientationInfo"
      />
    </div>
    <ButtonBase
      theme="secondary"
      stroke="n"
      class="button"
      :disabled="false"
      rounded
      size="small"
      to="/mon-compte/modifier-mes-informations"
    >
      Modifier mes informations
    </ButtonBase>
    <hr v-if="profile.isASubscriber" />
    <div class="extended-infos">
      <AccountAsideExtendedItem
        v-if="profile.isASubscriber"
        :label="profile.products"
        :value="profile.plans"
        orientation="column"
      />
      <AccountButtonStripe v-if="profile.isStripe" />
    </div>
  </div>
</template>
<script setup lang="ts">
const user = useUserStore();
const profile = useProfileStore();
const formatedBirthDate = computed(() =>
  user.birthdate ? getFormatedBirthDate(user.birthdate) : null
);
const { isDesktop } = useEvaBreakpoints();
const orientationInfo = computed(() => (isDesktop.value ? 'column' : 'row'));
</script>
<style lang="scss" scoped>
.account-aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--gap_n);
  @include desktop {
    align-items: flex-start;
  }
}
.button {
  width: fit-content;
  margin: 1rem 0;
}
.extended-infos {
  display: flex;
  flex-direction: column;
  gap: var(--gap_n);
}
hr {
  width: 10rem;
  height: 0.05rem;
  margin: 0.6rem 0;
  border: none;
  background-color: var(--color_neutral_100);
  @include desktop {
    width: 100%;
  }
}
</style>
